module.exports = __webpack_public_path__ + "static/media/delivery-policy.f3b8a923.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/delivery-policy.pdf
// module id = 282
// module chunks = 0